import React, {Component} from 'react';
import {Header, Footer} from './Layouts'
import Dashboard from './Dashboard/Dashboard'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
    palette: {
      primary: {
        main: '#251447',
      },
      secondary: {
        light: '#0066ff',
        main: '#0044ff',
        contrastText: '#ffcc00',
      },
    },
  });

class MainScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    componentWillMount() {
        var MainScreen = [];
        MainScreen.push(
            <Dashboard parentContext = {this}
                appContext = {this.props.parentContext}
            />
        );
            this.setState({
                MainScreen: MainScreen,
            })
        }
        handleClick(event) {
           
        }
        render() {
            const {superadmin} = this.props
            return ( 
                <div className = "MainScreen"> 
        <MuiThemeProvider theme={theme}>
          <Header superadmin={superadmin}/>
          <Dashboard adminUid={this.props.adminUid} adminName={this.props.adminName}/>
          <Footer/>
        </MuiThemeProvider>
                </div>
            );
        }
    }

    export default MainScreen;


// WEBPACK FOOTER //
// ./src/Components/MainScreen.js